import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom';
import logo from '../../images/close-reading-logo-text.svg';
import { Button, Icon, Menu, Dropdown } from 'antd';
import SignUp from './SignUp.js';
import Login from './Login.js';

function SiteHeader(props){
  let right = null;
  const menu = (
    <Menu style = {{minWidth: '100px'}} theme="dark">
      <Menu.Item >
        <div onClick={props.logOut}>Logout</div>
      </Menu.Item>
    </Menu>
  );

  if(props.home.user){
    right = [
      <li key="catalog"><Link to="/catalog/courses">Catalog</Link></li>,
      <li style={{lineHeight: '45px', marginTop: '5px'}}key="user">
        <Dropdown id="CourseMenu" placement="bottomRight" overlay={menu}>
          <Icon id="home-header-user" type="user" />
        </Dropdown>
      </li>
    ];
  } else if(props.home.user === false) {
    right = [
      <li key="catalog"><Link to="/catalog/courses">Catalog</Link></li>,
      <li key="sign-up"><SignUp fetchUser={props.fetchUser}><Button id="btn-home-signup">Sign Up for Free!</Button></SignUp></li>,
      <li key="login"><Login fetchUser={props.fetchUser}><a>Login</a></Login></li>
    ]
  }

  return (
    <header id="SiteHeader">
      <Link to="/"><img alt="Close Reading" src={logo} id="home-header-logo" /></Link>
      <ul id="home-header-right">
        {right}
      </ul>
      <div className="clear"></div>
    </header>
  )
}

export default SiteHeader;



// WEBPACK FOOTER //
// ./src/components/Site/SiteHeader.js